import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import ClientForm from './ClientForm';
import CardHeader from 'react/shared/components/true_link/main/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/main/form/wizard/NextPageButton';
import { mediumBreakpointMediaQuery } from 'react/shared/theme/Theme';
import schema from 'react/shared/utils/schemas';
import trackUserData from 'react/signups/card/common/MarketoTracker';
import PrivacyPolicyAndTermsOfServiceLinks from 'react/signups/card/common/PrivacyPolicyAndTermsOfServiceLinks';
import WizardCard from 'react/signups/card/common/WizardCard';
import credentialsShape from 'react/signups/card/shapes/Credentials';

export default function Client({ credentials, moduleComplete, setCredentials }) {
  const validationSchema = Yup.object().shape({
    email: schema.email.required(),
    password: schema.password.required(),
    passwordConfirmation: schema.passwordConfirmation.required(),
  });

  const desktop = useMediaQuery(mediumBreakpointMediaQuery);

  const handleContinue = (values) => {
    trackUserData({
      Email: values.email,
    });
    setCredentials({
      email: values.email,
      password: values.password,
      passwordConfirmation: values.passwordConfirmation,
    });
  };

  return (
    <WizardCard>
      <CardHeader>Create your account login</CardHeader>
      <Formik
        initialValues={credentials}
        onSubmit={handleContinue}
        validationSchema={validationSchema}
      >
        {({ handleChange, handleSubmit, setFieldTouched, values }) => (
          <>
            <ClientForm
              onChange={handleChange}
              onContinue={handleSubmit}
              setFieldTouched={setFieldTouched}
              values={values}
            />
            <Grid alignItems="center" container justifyContent="flex-start">
              {!desktop && (
                <Grid item xs={12}>
                  <PrivacyPolicyAndTermsOfServiceLinks />
                </Grid>
              )}
              <Grid item md={3} xs={12}>
                <NextPageButton disabled={moduleComplete} onClick={handleSubmit} />
              </Grid>
              {desktop && (
                <Grid item md={8}>
                  <PrivacyPolicyAndTermsOfServiceLinks />
                </Grid>
              )}
            </Grid>
          </>
        )}
      </Formik>
    </WizardCard>
  );
}

Client.propTypes = {
  credentials: credentialsShape.isRequired,
  moduleComplete: PropTypes.bool.isRequired,
  setCredentials: PropTypes.func.isRequired,
};
